import { parseISO, format } from "date-fns"
// import { th } from 'date-fns/locale'

const dateFns = {
    parseISO, format
}

const plugin = {
    install: function (Vue) {

        Vue.prototype.dateFns = dateFns
        Vue.dateFns = dateFns

        Vue.filter("dateFns", function (value, format = "dd-MM-yyyy HH:mm") {
            // return value
            if (value != null && value != "") {
                // check type
                let dtObj = null
                if (typeof value === "number") {
                    dtObj = new Date(value)
                } else {
                    dtObj = dateFns.parseISO(value)
                }

                // console.log(value)
                let result = dateFns.format(dtObj, format)
                // console.log(result)
                return result
            } else {
                return ""
            }
        })
    }
}

export default { plugin }